import script from "./BeiguoProductComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BeiguoProductComponent.vue?vue&type=script&setup=true&lang=js"

import "./BeiguoProductComponent.vue?vue&type=style&index=0&id=16cee3a5&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16cee3a5"]])

export default __exports__